import React, { useEffect, useRef, useState } from "react";
import { copyToClipboard } from "../../utils/clipboard";

/*
    Small copy-to-clipboard button.

    `value` may be credential material, so it is neither logged nor stored
    anywhere but the clipboard.

    `variant` picks one of the shared .gb-btn styles: the per-field copies sit
    next to an input and stay quiet, while "Copy all three" in the credential
    reveal is the action we actually want taken and is the green primary.
*/
const CopyButton = ({
  value,
  label = "Copy",
  copiedLabel = "Copied",
  className = "",
  disabled = false,
  variant = "secondary",
  ariaLabel,
}) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
    []
  );

  const handleCopy = async () => {
    const ok = await copyToClipboard(value);
    setCopied(ok);
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      className={`gb-btn gb-btn--${variant} api-access__copy-btn ${className}`}
      onClick={handleCopy}
      disabled={disabled || !value}
      aria-label={ariaLabel || label}
    >
      {copied ? copiedLabel : label}
    </button>
  );
};

export default CopyButton;
